import { Component, HostBinding, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { FADE_IN_ANIMATION } from './../../../shared/animations/animations';

@Component({
    selector: 'gl-right',
    templateUrl: './right.component.html',
    styleUrls: ['./right.component.scss'],
    animations: [FADE_IN_ANIMATION],
    standalone: false
})
export class RightComponent {
  @HostBinding('class.success') @Input() public success: boolean;
  @HostBinding('class.failure') @Input() public failure: boolean;
  @HostBinding('@show') public show;
  public isMobile: boolean;
  @Input() public goToApp: boolean;
  @Input() public isRegistered: boolean;

  constructor(private navigationService: NavigationService, private router: Router) {
    this.isMobile = this.router.url.includes('mobile') ? true : false;
  }

  public goToLogin(): void {
    this.navigationService.navigateToLogin();
  }

  public goToHomepage(): void {
    this.navigationService.navigateToHomepage();
  }

  public goToRegister(): void {
    this.navigationService.navigateToRegister();
  }
}
